import { render, staticRenderFns } from "./FundDetails.vue?vue&type=template&id=1b8d488b&scoped=true"
import script from "./FundDetails.vue?vue&type=script&lang=js"
export * from "./FundDetails.vue?vue&type=script&lang=js"
import style0 from "./FundDetails.vue?vue&type=style&index=0&id=1b8d488b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8d488b",
  null
  
)

export default component.exports